import { z } from "zod";

import { MessageDTO } from "./Message";
import { ContactDTO } from "./Contact";

export enum Language {
  ENGLISH = "ENGLISH",
  SPANISH = "SPANISH",
}

export const ChatDTO = z.object({
  id: z.string(),
  contact: ContactDTO.or(z.string()),
  language: z.nativeEnum(Language).optional(),
  creationDate: z
    .string()
    .transform((date) => new Date(date))
    .or(z.date()),
  messages: z.array(MessageDTO),
});

export type Chat = z.infer<typeof ChatDTO>;
